import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AppBar, Box, Paper, Tab, Tabs, Typography } from '@material-ui/core';
import { myContainerStyle } from '../../../configs/ui/constant';
import { useRouteMatch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import ApprovePtoGSB from '../../../components/Tabs/Approve/ApprovePtoGSB';
import ApproveGSBtoP from '../../../components/Tabs/Approve/ApproveGSBtoP';
import { GSBtoWording } from "../../../configs/helpers/GSBtoWording"

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));
function TabPanel(props) {
   const { children, value, index, ...other } = props;
   return (
      <div
         role='tabpanel'
         hidden={value !== index}
         id={`simple-tabpanel-${index}`}
         aria-labelledby={`simple-tab-${index}`}
         {...other}
      >
         {value === index && <Box p={3}>{children}</Box>}
      </div>
   );
}
TabPanel.propTypes = {
   children: PropTypes.node,
   index: PropTypes.any.isRequired,
   value: PropTypes.any.isRequired,
};

function ManageApproveProcess(props) {
   const classes = useStyles();
   let { path, url } = useRouteMatch();
   const [tabValue, setTabValue] = useState(0);

   const handleChangeTabValue = (event, newValue) => {
      setTabValue(newValue);
   };
   return (
      <Paper style={myContainerStyle.root}>
         <Box my={1}>
            <Box display='flex' alignItems='center'>
               <Box mx={1}>
                  <Typography variant='h5'>Manage Approve Process</Typography>
               </Box>
            </Box>
         </Box>
         <Box className='tabs'>
            <AppBar position='static'>
               <Tabs
                  value={tabValue}
                  onChange={handleChangeTabValue}
                  aria-label='Manage Approve Process tab'
               >
                  <Tab
                     label='จัดการคะแนน P → P, P → GSB Way of Work'
                     style={{ textTransform: 'none' }}
                  />
                  <Tab
                     label='จัดการคะแนน GSB Way of Work → GSB Way of Work'
                     style={{ textTransform: 'none' }}
                  />
               </Tabs>
            </AppBar>
         </Box>
         <Box>
            <TabPanel value={tabValue} index={0}>
               <ApprovePtoGSB />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
               <ApproveGSBtoP />
            </TabPanel>
         </Box>
      </Paper>
   );
}

export default ManageApproveProcess;
